function mediaSizeSwitch(img, size) {
    const imgParts = img.split('.');
    const imgExt = imgParts.pop();
    const newImg = `${imgParts.join(".")}.${size}.${imgExt}`;
    return newImg
}
export default mediaSizeSwitch;